import HttpRequest from '@/libs/axios'
const axios = new HttpRequest(process.env.VUE_APP_BASE_URL)
const axiosready = new HttpRequest(process.env.VUE_APP_BASE_READ_ONLY_URL)
export { axios, axiosready }
